//이벤트 전용 bus
import Vue from 'vue'
export const eventHub = new Vue();